import { ScheduleState } from "../../../type/schedule-state";

export const clearSelectedClientIdsDispatch = (state: ScheduleState) => {
  state.selectedClientIds = [];
};
